export default __webpack_public_path__ + "static/media/table-arrow-left.23337615.svg";